export const flag = {
  flag: {
    shape:
      '<path fill="#006ADB" d="M6 20.5V5h7.2l.4 2H19v8h-5.2l-.4-2H7v7.5H6Zm8.65-6.5H18V8h-5.25l-.4-2H7v6h7.25l.4 2Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
